<template>
  <div>
    <!-- informations générales -->
    <div class="table-responsive">
      <h3 id="tabletitle1">{{ $t('general_infos') }}</h3>
      <table :id="tableid + '1'" class="table table-striped">
        <tbody>
          <tr v-for="key in generalInfos">
            <th>{{ $t(key) }}</th><td>{{ profile[key] }}</td>
          </tr>
          <tr>
            <th>{{ $t('address') }}</th><td>{{ addressString }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Recipient details -->
    <div class="table-responsive">
      <h3 id="tabletitle2">{{ $t('recipient_infos') }}</h3>
      <table :id="tableid + '2'" class="table table-striped">
        <tbody>
          <tr v-for="info in recipientInfos" v-if="recipient[info.key]">
            <th>{{ $t(info.key) }}</th><td>{{ info.translate != null ? $t(info.translate + recipient[info.key]) : recipient[info.key] }}</td>
          </tr>
          <tr v-for="number in numbersSources">
            <th>{{ $t(number.number) }}</th><td>{{ recipient[number.number] }} / {{ recipient[number.source] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Skills -->
    <div v-if="skills.length > 0" class="table-responsive">
      <h3 id="tabletitle3">{{ $t('professional_skills') }}</h3>
      <table :id="tableid + '3'" class="table table-striped">
        <thead>
          <tr>
            <th v-for="field in skillsFields">{{ $t(field) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="skill in skills">
            <td v-for="field in skillsFields">{{ skill[field] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Professionnal experiences -->
    <div v-if="experiences.length > 0" class="table-responsive">
      <h3 id="tabletitle4">{{ $t('professional_experiences') }}</h3>
      <table :id="tableid + '4'" class="table table-striped">
        <thead>
          <tr>
            <th v-for="field in experiencesFields">{{ $t(field) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="exp in experiences">
            <td v-for="field in experiencesFields">{{ exp[field] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Third Parties -->
    <div class="table-responsive">
      <h3 id="tabletitle5">{{ $t('third_parties') }}</h3>
      <table v-for="(tp, index) in third_parties" :id="tableid + '5tp' + (index+1)" class="table table-striped">
        <tbody>
          <tr v-for="field in thirdPartiesField">
            <th>{{ $t(field) }}</th><td v-if="field != 'occupation'">{{ tp[field] }}</td><td v-else>{{ tp.type.title }}</td>
          </tr>
          <tr>
            <th>{{ $t('address') }}</th><td>{{ thirdPartyAddress(tp) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Origins of mandate -->
    <div v-if="displayedOrigins.length > 0" class="table-responsive">
      <h3 id="tabletitle6">{{ $t('origin_mandate') }}</h3>
      <div v-for="(or, index) in displayedOrigins">
        <table :id="tableid + '6om' + (index+1)" class="table table-striped">
          <thead>
            <tr>
              <th>{{ index+1 }}. {{ $t('origins.' + or.type.id) }}</th><th>adssdf</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(key, field) in originsFields" v-if="isVisible(or.type.value, key)">
              <th>{{ $t(field) }}</th><td v-if="field == 'contact_gender'">{{ $t('genders.' + or[field]) }}</td><td v-else>{{ or[field] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--Nature of mandate -->
    <div v-if="showNatureOfMandate" class="table-responsive">
      <h3 id="tabletitle7">{{ $t('nature_mandate') }}</h3>
      <table :id="tableid + '7'" class="table table-striped">
        <tbody>
          <tr v-for="(opt, index) in natureOptions" v-if="natureOfMandate[opt]">
            <td>- {{ $t(opt) }}</td>
          </tr>
          <tr v-if="natureOfMandate.other_nature">
            <td>- {{ natureOfMandate.other_nature }}</td>
          </tr>
        </tbody>
      </table>
      <h5 v-if="natureOfMandate['additional_informations']">{{ $t('nature_mandate_additional') }}</h5>
      <table v-if="natureOfMandate['additional_informations']" class="table table-striped">
        <tbody>
          <tr>
            <td>{{ natureOfMandate['additional_informations'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Health diagnosis -->
    <div class="table-responsive">
      <h3 id="tabletitle8">{{ $t('recipient_health') }}</h3>
      <h5 id="tabletitle8-1">{{ $t('medical_diagnosis') }}</h5>
      <table :id="tableid + '8'" class="table table-striped">
        <tbody>
          <tr>
            <td>{{ recipient['medical_diagnosis'] ? recipient['medical_diagnosis'] : '/' }}</td>
          </tr>
        </tbody>
      </table>
      <h5 id="tabletitle9">{{ $t('health_problems') }}</h5>
      <table :id="tableid + '9'" class="table">
        <thead>
          <th>{{ $t('name') }}</th><th>{{ $t('difficulty') }}</th>
        </thead>
        <tbody>
          <tr v-for="(diff, index) in difficulties">
            <th>{{ $t(diff) }}</th><td>{{ difficultyChecked(index, recipient['difficulties']) ? recipient[diff] == null ? $t('yes') : recipient[diff] : $t('none') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Life Context -->
    <div class="table-responsive">
      <h3 id="tabletitle10">{{ $t('life_context') }}</h3>
      <table :id="tableid + '10'" class="table table-striped">
        <thead>
          <tr>
            <th scope="col" class="w-50">{{ $t('life_habits') }}</th>
            <th scope="col" class="w-50">{{ $t('score') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="w-50"/>
            <td class="w-50">
              <small>
                <div v-for="(info, index) in $t('profile.context.habits.infos')">
                  <b>{{ index }}</b> : <span v-html="info"/><br>
                </div>
                <div>
                  <b>?</b> : {{ $t('profile.context.unknown') }}
                </div>
              </small>
            </td>
          </tr>
          <tr v-for="(habit, key) in contextHabits">
            <td>
              {{ $t(contextHabitsMessages[key]) }}<br>
              <small class="text-muted">{{ $t(contextHabitsMessages[key] + '_description') }}</small>
            </td>
            <td>{{ formatHabitValue(recipient[habit]) }}</td>
          </tr>
        </tbody>
      </table>

      <!-- INSERT ADDITIONAL informations-->
      <div v-if="recipient['factors_comments']">
        <h5 id="tabletitle11">{{ $t('comments_description') }}</h5>
        <table :id="tableid + '11'" class="table table-striped">
          <tbody>
            <tr>
              <td>{{ recipient['factors_comments'] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table :id="tableid + '12'" class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ $t('environment') }}</th>
            <th scope="col">{{ $t('score') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td/>
            <td>
              <small>
                <div v-for="(info, index) in $t('profile.context.environment.infos')">
                  <b>{{ index - 2 }}</b> : <span v-html="info"/><br>
                </div>
                <div>
                  <b>?</b> : {{ $t('profile.context.unknown') }}
                </div>
                <div>
                  <b>×</b> : {{ $t('profile.context.unavailable') }}
                </div>
              </small>
            </td>
          </tr>
          <tr v-for="(env, key) in contextEnvironment">
            <td>{{ $t(contextEnvironmentMessages[key]) }}</td>
            <td>{{ formatEnvValue(recipient[env]) }}</td>
          </tr>
        </tbody>
      </table>

      <div v-if="recipient['environment_comments']">
        <h5 id="tabletitle13">{{ $t('comments') }}</h5>
        <table :id="tableid + '13'" class="table table-striped">
          <tbody>
            <tr>
              <td>{{ recipient['environment_comments'] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'ProfileDisplay',

  props: {
    profile: {
      type: Object,
      required: true
    },
    tableid: {
      type: String,
      required: true
    }
  },

  data: () => ({
    generalInfos: ['first_name', 'last_name', 'email', 'phone'],
    address: [{ key: 'address', translate: null }, { key: 'postal_code', translate: null }, { key: 'location', translate: null }, { key: 'country', translate: 'nationalities.' }],
    recipientInfos: [{ key: 'gender', translate: 'genders.' }, { key: 'nationality', translate: 'nationalities.' }, { key: 'birth_day', translate: null }, { key: 'birth_place', translate: null },
      { key: 'language', translate: 'languages.' }, { key: 'occupation', translate: '' }, { key: 'occupation_name', translate: null }],
    numbersSources: [{ number: 'reference_number', source: 'reference_number_source' }, { number: 'file_number', source: 'file_number_source' }],
    difficulties: ['difficulty_intellectual_activities', 'difficulty_language', 'difficulty_behavior', 'difficulty_senses',
      'difficulty_motor_activity', 'difficulty_breathing', 'difficulty_digestion', 'difficulty_excretion', 'difficulty_protection'],
    thirdPartiesField: ['name', 'occupation', 'comment', 'phone', 'email'],
    thirdPartiesAddressField: ['address', 'postal_code', 'location'],
    third_parties: [],
    skillsFields: ['title', 'year'],
    skills: [],
    experiencesFields: ['title', 'year_start', 'year_end'],
    experiences: [],
    origins: [],
    originsFields: {
      'organization_name': 1,
      'organization_activity': 2,
      'organization_department': 4,
      'contact_name': 8,
      'contact_function': 16,
      'contact_address': 32,
      'contact_postal_code': 64,
      'contact_locality': 128,
      'contact_phone': 256,
      'contact_email': 512,
      // Champ caché en front pour le moment, conservé côté backend/DB
      // pour permettre un retour ultérieur sans migration de données.
      // 'contact_gender': 1024,
      'contact_occupation': 2048,
      'contact_activities': 4096,
      'contact_kinship': 8192
    },
    natureOptions: [
      'professionnal_activity_capability',
      'professionnal_orientation',
      'formation_orientation',
      'work_organization_adaptation',
      'work_time_adaptation',
      'work_place_adaptation',
      'retrain_for_work',
      'anticipate_reeducation',
      'volunteer_social_orientation',
      'professional_skills_consciousness',
      'professional_project_help',
      'financial_compensation',
      'stop_professionnal_activity',
      'find_adapted_job'
    ],
    contextEnvironment: [
    	'environment_attitude_relatives',
    	'environment_earnings',
    	'environment_transportation',
    	'environment_attitude_coworkers',
    	'environment_attitude_hierarchy',
    	'environment_accessibility_workplaces',
    	'environment_equipment',
    	'environment_systems',
    	'environment_scheduling',
    	'environment_quality',
    	'environment_accessbility_others'
    ],
    contextEnvironmentMessages: [
    	'attitude_and_support_family',
    	'income_and_savings',
    	'transport_means',
    	'attitude_and_support_coworkers',
    	'attitude_and_support_hierarchy',
    	'physical_accessibility',
    	'work_equipment',
    	'communication_system',
    	'working_time_organization',
    	'working_environment',
    	'accessibility_other_places'
    ],
    contextHabits: [
    	'factors_nutrition',
    	'factors_care',
    	'factors_travel',
    	'factors_responsibilities'
    ],
    contextHabitsMessages: [
    	'nutrition',
    	'personal_care',
    	'travel',
    	'responsabilities'
    ]
  }),

  computed: {
    addressString: function () {
      return this.address.filter(x => this.profile[x.key] != null).map(x => x.translate ? this.$t(x.translate + this.profile[x.key]) : this.profile[x.key]).join(', ')
    },

    recipient: function () {
      return this.profile.recipient
    },

    natureOfMandate: function () {
      return this.profile.recipient.nature_of_mandate
    },

    displayedOrigins: function () {
      var show = this.origins.show
      var keys = Object.keys(this.origins).filter(x => show[x])
      var ret = []
      for (var i = 0; i < keys.length; i++) {
        ret.push(this.origins[keys[i]])
      }
      return ret
    },

    showNatureOfMandate: function () {
      var ret = false

      for (var i = 0; i < this.natureOptions; i++) {
        ret |= this.natureOfMandate[this.natureOptions[i]] == '1'
      }

      ret |= !this.natureOfMandate.other_nature
      ret = Boolean(ret)

      return ret
    }
  },

  mounted () {
    this.loadThirdParties()
    this.loadSkills()
    this.loadExperience()
    this.loadOrigins()
  },

  methods: {
    difficultyChecked (index, difficulty) {
      return (Math.pow(2, index) & difficulty) == Math.pow(2, index)
    },

    thirdPartyAddress (tp) {
      return this.thirdPartiesAddressField.map(x => tp[x]).join(', ')
    },

    isVisible (value, fieldValue) {
      return (value & fieldValue) == fieldValue
    },

    formatEnvValue (val) {
      if (val == 0 || !val) return ''
      if (val == 6) return '?'
      if (val == 7) return 'X'
      return val - 3
    },

    formatHabitValue (val) {
      if (val == 6) return '?'
      if (val == 7) return 'X'
      return val
    },

    loadThirdParties () {
      axios.get('/api/users/' + this.profile.id + '/thirdparties')
        .then(response => {
          this.third_parties = response.data
        })
        .catch(e => {
          console.error(e)
        })
    },

    loadSkills () {
      axios.get('/api/users/' + this.profile.id + '/skills')
        .then((response) => {
          this.skills = response.data
        })
        .catch((e) => {
          console.error(e)
        })
    },

    loadExperience () {
      axios.get('/api/users/' + this.profile.id + '/experiences')
        .then((response) => {
          this.experiences = response.data
        }).catch((e) => {
          console.error(e)
        })
    },

    loadOrigins () {
      axios.get('/api/users/' + this.profile.id + '/origins')
        .then(response => {
          this.origins = response.data
        })
        .catch(e => {
          console.error(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ProfileDisplay.vue